'<template>
   <div class="page_member_join_container" v-loading="loading">
      <div class="max_width">
         <div class="container_nav">
            当前位置：<router-link to="/">首页 - </router-link><a>入会申请</a>
         </div>
         <div class="form_content">
            <el-form :model="ruhuiForm" ref="ruhuiForm" class="ruhui_formbox" :rules="ruhuiRules">
               <el-form-item label="LOGO：" prop="logo">
                  <el-upload action="" class="imgupload" :multiple="true" accept=".bmp,.gif,.jpg,.jpeg,.png" :auto-upload="true" :limit="fileNum" action="" :http-request="handleUpload" ref="sdsupload" :show-file-list="false" :on-remove="handleRemove" :on-preview="handlePictureCardPreview" :on-exceed="onExceed">
                     <div v-if="ruhuiForm.logo == ''">
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                     </div>
                     <img v-else :src="ruhuiForm.logo" class="avatar">
                  </el-upload>
               </el-form-item>
               <el-form-item label="单位名称：" prop="danwei">
                  <el-input v-model="ruhuiForm.danwei"></el-input>
               </el-form-item>
               <el-form-item label="单位简称：" prop="jiancheng">
                  <el-input v-model="ruhuiForm.jiancheng" autocomplete="off"></el-input>
               </el-form-item>
               <el-form-item label="公司类型：" prop="kind">
                  <el-select v-model="ruhuiForm.kind" placeholder="请选择类型">
                     <el-option label="机关" value="机关"></el-option>
                     <el-option label="事业单位" value="事业单位"></el-option>
                     <el-option label="国有企业" value="国有企业"></el-option>
                     <el-option label="民营企业" value="民营企业"></el-option>
                     <el-option label="社会团体" value="社会团体"></el-option>
                     <el-option label="民办非企业单位" value="民办非企业单位"></el-option>
                     <el-option label="基金会" value="基金会"></el-option>
                     <el-option label="其他" value="其他"></el-option>
                  </el-select>
               </el-form-item>
               <el-form-item label="联 系 人：" prop="lianxiren">
                  <el-input v-model="ruhuiForm.lianxiren" autocomplete="off"></el-input>
               </el-form-item>
               <el-form-item label="联系电话：" prop="lianxiTel">
                  <el-input v-model="ruhuiForm.lianxiTel" maxlength="11" autocomplete="off"></el-input>
               </el-form-item>
               <el-form-item label="其他信息：" prop="beizhu">
                  <el-input type="textarea" :rows="2" v-model="ruhuiForm.beizhu" autocomplete="off"></el-input>
               </el-form-item>
               <el-form-item label="入会登记表：" prop="filePath1">
                  <el-col :span="10">
                     <el-upload action="" :multiple="true" accept=".doc,.docx,.xls,.pdf,.jpg,.png,.jpeg" :auto-upload="true" :limit="fileNum" action="" name="filePath1" :http-request="handleUpload2" ref="filePath1" :show-file-list="false" :on-exceed="onExceed">
                        <div v-if="ruhuiForm.filePath1 != ''">
                           <span>{{ruhuiForm.filePath1_name}}</span>
                        </div>
                        <el-button size="small" type="primary" v-if="ruhuiForm.filePath1 == ''">点击上传</el-button>
                        <el-button class="down_btns" size="small" type="primary" v-else>重新上传</el-button>
                     </el-upload>
                  </el-col>
                  <el-col :span="6">
                     <div class="down_box">
                        <a href="/web/down/入会登记表.xls" target="_blank">资料模板下载</a>
                     </div>
                  </el-col>
               </el-form-item>
               <el-form-item label="理事候选人推荐表：" prop="filePath2">
                  <el-col :span="10">
                     <el-upload action="" :multiple="true" accept=".doc,.docx,.xls,.pdf,.jpg,.png,.jpeg" :auto-upload="true" :limit="fileNum" action="" name="filePath2" :http-request="handleUpload2" ref="filePath2" :show-file-list="false" :on-exceed="onExceed">
                        <div v-if="ruhuiForm.filePath2 != ''">
                           <span>{{ruhuiForm.filePath2_name}}</span>
                        </div>
                        <el-button size="small" type="primary" v-if="ruhuiForm.filePath2 == ''">点击上传</el-button>
                        <el-button class="down_btns"  size="small" type="primary" v-else>重新上传</el-button>
                     </el-upload>
                  </el-col>
                  <el-col :span="6">
                     <div class="down_box">
                        <a href="/web/down/附表1.理事候选人推荐表.docx" target="_blank">资料模板下载</a>
                     </div>
                  </el-col>
               </el-form-item>
               <el-form-item label="内审工作联系人推荐表：" prop="filePath3">
                  <el-col :span="10">
                     <el-upload action="" :multiple="true" accept=".doc,.docx,.xls,.pdf,.jpg,.png,.jpeg" :auto-upload="true" :limit="fileNum" action="" name="filePath3" :http-request="handleUpload2" ref="filePath3" :show-file-list="false" :on-exceed="onExceed">
                        <div v-if="ruhuiForm.filePath3 != ''">
                           <span>{{ruhuiForm.filePath3_name}}</span>
                        </div>
                        <el-button size="small" type="primary" v-if="ruhuiForm.filePath3 == ''">点击上传</el-button>
                        <el-button class="down_btns" size="small" type="primary" v-else>重新上传</el-button>
                     </el-upload>
                  </el-col>
                  <el-col :span="6">
                     <div class="down_box">
                        <a href="/web/down/附表2.内审工作联系人推荐表.docx" target="_blank">资料模板下载</a>
                     </div>
                  </el-col>
               </el-form-item>
               <el-form-item label="营业执照：" prop="filePath4">
                  <el-col :span="10">
                     <el-upload action="" :multiple="true" accept=".doc,.docx,.pdf,.jpg,.png,.jpeg" :auto-upload="true" :limit="fileNum" 
                      action="" name="filePath4" ref="filePath4" 
                      :http-request="handleUpload2" :show-file-list="false" :on-exceed="onExceed">
                        <div v-if="ruhuiForm.filePath4 != ''">
                           <span>{{ruhuiForm.filePath4_name}}</span>
                        </div>
                        <el-button size="small" type="primary" v-if="ruhuiForm.filePath4 == ''">点击上传</el-button>
                        <el-button class="down_btns" size="small" type="primary" v-else>重新上传</el-button>
                     </el-upload>
                  </el-col>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" class="tijiao_btns" @click="submitForm('ruhuiForm')">提交</el-button>
               </el-form-item>
            </el-form>
         </div>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   export default {
      name: 'user_member_join_page',
      components: {

      },

      data() {
         const validatePhone = (rule, value, callback) => {
            // console.log(rule)
            // console.log(value)
            // console.log(callback)

            // 判断输入框中是否输入手机号
            if (!value) {
               callback(new Error('手机号不能为空'))
            }
            //正则表达式进行验证手机号，从1开始，第二位是35789中的任意一位，以9数字结尾
            if (!/^1\d{10}$/.test(value)) {
               callback(new Error('手机号格式不正确'))
            }
            callback()
         }
         return {
            loading: false,

            ruhuiStatur: true, //入会弹框
            ruhuiForm: {
               appId: "",
               logo: '',
               danwei: '',
               jiancheng: '',
               kind: '',
               lianxiren: '',
               lianxiTel: '',
               filePath1: '',
               filePath1_name: '',
               filePath2: '',
               filePath2_name: '',
               filePath3: '',
               filePath3_name: '',
               filePath4: '',
               filePath4_name: '',
            },
            ruhuiRules: {
               logo: [{
                  required: true,
                  message: '请上传LOGO',
                  trigger: 'change'
               }],
               danwei: [{
                  required: true,
                  message: '请输入单位名称',
                  trigger: 'blur'
               }, ],
               jiancheng: [{
                  required: true,
                  message: '请输入单位简称',
                  trigger: 'blur'
               }, ],
               kind: [{
                  required: true,
                  message: '请选择公司类型',
                  trigger: 'change'
               }, ],
               lianxiren: [{
                  required: true,
                  message: '请输入联系人',
                  trigger: 'blur'
               }, ],
               lianxiTel: [{
                     required: true,
                     message: '请输入联系电话',
                     trigger: 'blur'
                  },
                  {
                     required: true,
                     trigger: 'blur',
                     validator: validatePhone
                  }
               ],
               filePath1: [{
                  required: true,
                  message: '请上传资料',
                  trigger: 'change'
               }, ],
               filePath2: [ {
                  required: true,
                  validator: (rule, value, callback) => {
                     // 验证 filePath2 和 filePath3 至少有一个被填写
                     if (!this.ruhuiForm.filePath2 && !this.ruhuiForm.filePath3) {
                        callback(new Error('请上传理事候选人推荐表或内审工作联系人推荐表（至少一个）'))
                     } else {
                        callback()
                     }
                  },
                  trigger: 'change'
               } 
             ],
               filePath3: [ {
                  required: true,
                  validator: (rule, value, callback) => {
                     // 验证 filePath2 和 filePath3 至少有一个被填写
                     if (!this.ruhuiForm.filePath2 && !this.ruhuiForm.filePath3) {
                        callback(new Error('请上传理事候选人推荐表或内审工作联系人推荐表（至少一个）'))
                     } else {
                        callback()
                     }
                  },
                  trigger: 'change'
               }, ],
               filePath4: [{
                  required: true,
                  message: '请上传资料',
                  trigger: 'change'
               }, ],
            },
            fileNum: 1, //最多上传数量

         };
      },
      mounted() {

      },
      methods: {

         //上传图片
         handleRemove(file, fileList) {
            this.ruhuiForm.logo = fileList;
         },
         onExceed() {
            this.$message.error('超出最多上传数量！');
         },
         handleUpload(event) {
            var _this = this;
            const loading = this.$loading({
               lock: true,
               text: '上传中...',
               spinner: 'el-icon-loading',
            });
            var formData = new FormData();
            formData.append('file', event.file)
            this.$api.allupload(formData).then(res => {
               loading.close();
               if (res.code == 200) {
                  this.ruhuiForm.logo = res.url;
                  this.$refs.sdsupload.clearFiles()
               } else {
                  this.$refs.sdsupload.clearFiles()
                  this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });

         },
         handleUpload2(event) {
            var _this = this;
            const loading = this.$loading({
               lock: true,
               text: '上传中...',
               spinner: 'el-icon-loading',
            });
            var formData = new FormData();
            formData.append('file', event.file)
            this.$api.allupload(formData).then(res => {
               loading.close();
               if (res.code == 200) {
                  if(event.filename == 'filePath1'){
                     this.ruhuiForm.filePath1 = res.url;
                     this.ruhuiForm.filePath1_name = res.destFileName;
                  }
                  if(event.filename == 'filePath2'){
                     this.ruhuiForm.filePath2 = res.url;
                     this.ruhuiForm.filePath2_name = res.destFileName;
                  }
                  if(event.filename == 'filePath3'){
                     this.ruhuiForm.filePath3 = res.url;
                     this.ruhuiForm.filePath3_name = res.destFileName;
                  }
                  if(event.filename == 'filePath4'){
                     this.ruhuiForm.filePath4 = res.url;
                     this.ruhuiForm.filePath4_name = res.destFileName;
                  }
                  this.$refs[event.filename].clearFiles()
               } else {
                  this.$refs[event.filename].clearFiles()
                  this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });

         },
         handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
         },

         //提交申请
         submitForm(formName) {
            var _this = this;
            this.$refs[formName].validate((valid) => {
               if (valid) {
                  const loading = this.$loading({
                     lock: true,
                     text: '提交中...',
                     spinner: 'el-icon-loading',
                  });
                  _this.$api.ruhuiBaoming(_this.ruhuiForm).then(res => {
                     loading.close();
                     if (res.code == 200) {
                        _this.$alert('提交入会申请成功！点击确定后返回首页', '提示', {
                           type: 'success',
                           confirmButtonText: '确定'
                        }).then(() => {
                           _this.$router.push('/');
                        });
                         // 清空表单
                         _this.ruhuiForm = {
                           appId: "",
                           logo: '',
                           danwei: '',
                           jiancheng: '',
                           kind: '',
                           lianxiren: '',
                           lianxiTel: '',
                           filePath1: '',
                           filePath1_name: '',
                           filePath2: '',
                           filePath2_name: '',
                           filePath3: '',
                           filePath3_name: '',
                           filePath4: '',
                           filePath4_name: '',
                        };
                        // 清除表单验证状态
                        _this.$refs.ruhuiForm.resetFields();
                        _this.ruhuiStatur = false;
                     } else {
                        _this.$message.error(res.msg);
                     }
                  }).catch(function(error) {
                     loading.close();
                     _this.loading = false;
                     _this.$message.error(error.msg);
                  });
               } else {
                  console.log('error submit!!');
                  return false;
               }
            });
         },

         //关闭弹框
         closedialog() {
            this.$emit('close')
         }
      }
   }
</script>
<style lang="less">

</style>
